/**
 * useSubscription — hook for checking subscription status.
 */

import { useCreditsStore } from '../store/creditsStore';

export function useSubscription() {
  const { subscription } = useCreditsStore();

  const isSubscribed = subscription?.status === 'active' && !!subscription?.plan && subscription.plan !== 'free';
  const plan = subscription?.plan ?? null;

  const hasFeature = (feature: string): boolean => {
    if (!isSubscribed) return false;
    const proFeatures = ['deep_analysis', 'pdf_export', 'priority_support'];
    return proFeatures.includes(feature);
  };

  return { isSubscribed, plan, hasFeature };
}
